module.exports = __webpack_public_path__ + "img/Proposed_flag_of_Antarctica.d20eee4b.svg";